import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './PageHeader.css';

export function BackButton({ onClick, label = '返回上一頁' }) {
  return (
    <button type="button" className="page-header__back" aria-label={label} onClick={onClick}>
      <ArrowLeft size={20} />
    </button>
  );
}

export default function PageHeader({
  title,
  subtitle,
  backLabel = '返回上一頁',
  onBack,
  rightAction = null,
  maxWidth = 1120,
  sticky = true,
  showBack = true
}) {
  return (
    <header className={`page-header${sticky ? ' page-header--sticky' : ''}`}>
      <div className="page-header__inner" style={{ maxWidth }}>
        {showBack && <BackButton onClick={onBack} label={backLabel} />}
        <div className="page-header__copy">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {rightAction && <div className="page-header__action">{rightAction}</div>}
      </div>
    </header>
  );
}
